import "./ModalContent2.scss";

function ModalContent2() {
  return (
    <div className="modal-content-2">
      <h1>MC2</h1>
    </div>
  );
}

export default ModalContent2;
